export const homeObjOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Prime Avastro$",
  headline: "Become so financially secure that you forget it's payday.",
  description:
    "Get access to our exclusive money lessons inspired by self-established billionaires. Enjoy the early access deals.",
  buttonLabel: "Get Started",
  imgStart: false,
  img: require("../../images/svg-1.svg").default,
  alt: "Car",
  dark: true,
  primary: true,
  darkText: false,
};

export const homeObjTwo = {
  id: "discover",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "$AVE $MART",
  headline: "Learn money saving tips by enrolling now.",
  description:
    "We have got you the top educators from all over the world, all set to make you a financially independent person.",
  buttonLabel: "Learn More",
  imgStart: true,
  img: require("../../images/svg-2.svg").default,
  alt: "Piggybank",
  dark: false,
  primary: false,
  darkText: true,
};

export const homeObjThree = {
  id: "signup",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Start Investing",
  headline: "Create your account to get started.",
  description:
    "Add your personal details like your full name and location where you live in and you are all set.",
  buttonLabel: "Enroll Now ",
  imgStart: false,
  img: require("../../images/svg-3.svg").default,
  alt: "investmentdata",
  dark: false,
  primary: false,
  darkText: true,
};
